export const READ_MORE_MS_DELAY = 300;
export const CLUSTERED_MARKERS_PER_ITERATION = 2000;
export const ACCEPT_IMAGE_FILETYPES = 'image/jpeg,image/png';
export const ACCEPT_ATTACHMENT_FILETYPES =
  'application/pdf,image/jpeg,image/png,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain';
export const PAGE_CUSTOMIZABLE_PREFIX = 'PAGE_CUSTOMIZABLE_';
